



















import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    Ref,
    ref,
} from '@vue/composition-api';

export default defineComponent({
    props: {
        value: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isNewUI: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        const selected = computed({
            get: () => {
                return props.value;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });
        const selectChange = () => {
            context.emit('change');
        };
        return {
            selected,
            selectChange
        };
    },
});
